import { render, staticRenderFns } from "./MoralPersonSearch.vue?vue&type=template&id=1fdcd9ac&scoped=true"
import script from "./MoralPersonSearch.vue?vue&type=script&lang=js"
export * from "./MoralPersonSearch.vue?vue&type=script&lang=js"
import style0 from "./MoralPersonSearch.vue?vue&type=style&index=0&id=1fdcd9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdcd9ac",
  null
  
)

export default component.exports